import { hashify } from '../utils/arrays';
import { pick } from '../utils/popups';
import Form from './form';





export default Form.extend( {

    bindingHandlers: {

        defaultPossibleValues: {
            set($el, value) {
                const { selected, options } = value;
                $el.html( ([ '' ].concat( options || [] ))
                    .map( s => `<option>${s}</option>` ) );
                $el.val( selected );
            },
            
            get($el, value, event) {
                return $el.val();
            }
        },

    },

    [Form.event( 'editable:manage-roles' )]() {
        const editable = [true, 't'].includes( this.model.get( 'editable_by_default' ) );
        const inverted = hashify( this.model.get( 'editable_inverted_for_roles' ), id => [+id, true] );
        const roles = this.options.roles.toJSON();
        const selected = roles.filter( role => editable ^ inverted[role.id] );

        pick( selected, {
            collection: this.options.roles,
            cluster: this.model.get( 'cluster' ),
            clusters: this.options.clusters,
            idOnly: true,
            fullCollection: true,
        } ).then( sel => {
            const newInverted = editable
                ? roles.map( role => +role.id ).filter( id => !sel.includes( id ) )
                : sel;

            // todo extra "unavailable" roles
            this.model.set( 'editable_inverted_for_roles', newInverted );
        } );
    },

} );


// WEBPACK FOOTER //
// ./src/js/view/field.fields.js